/**
 * Matches the backend's `providerKind` field on SchedulingProjectDataSource, and doubles as the
 * three tabs the Providers screen is split into. It exists because providerType values repeat
 * across kinds - the kind is what disambiguates them.
 */
export enum SiteProviderKind {
  DeliveryTime = "DELIVERY_TIME",
  ServiceTime = "SERVICE_TIME",
  Units = "UNITS"
}
